/**
 * Created by Gaplo917 on 9/7/2017.
 */
import * as PIXI from "pixi.js";
import R from "../config/R"

export default class Image extends PIXI.Sprite {
  constructor(x, y, texture){
    super(texture)
    this.anchor.x = 0.5
    this.anchor.y = 0.5
    this.x = x
    this.y = y
  }
}


// WEBPACK FOOTER //
// ./src/game/objects/Image.js